import React, { useEffect } from 'react'
import { preLoaderAnim } from '../../utils/loader';
import { markLoaderComplete } from '../../utils/loaderState';
import './Preloader.css'

const Preloader = () => {

    useEffect(()=>{
        preLoaderAnim();
        // Safety net: if the GSAP timeline is interrupted (e.g. the tab is
        // backgrounded), still release the intro so the page is never stuck.
        const fallback = setTimeout(markLoaderComplete, 6000);
        return () => clearTimeout(fallback);
    },[]);


  return (
    <div className='preloader'>
        <div className='texts-container'>
            <span id='text1'>Design,</span>
            <span id='text2'>Align,</span>
            <span id='text3'>Refine.</span>
        </div>
    </div>
  )
}

export default Preloader
